import React, { useState, useEffect } from 'react'; 
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; 
import logo from '../assets/images/nav-logo.png'; 

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const [isHappinessOpen, setIsHappinessOpen] = useState(false);
  const navigate = useNavigate();

  
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/TGSH/login";
  };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setScrolled(window.scrollY > 50);
  //   };
  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
    useEffect(() => {
      setIsOpen(false);
      setActiveDropdown(null);
      setIsHappinessOpen(false); 
    }, [location]);

    const toggleMenu = () => {
      setIsOpen(!isOpen);
      setActiveDropdown(null);
    };

    const toggleDropdown = (menuName) => {
      setActiveDropdown(activeDropdown === menuName ? null : menuName);
    };

  const SubMenuLink = ({ to, label, isNested = false, onClick }) => {
    const commonClasses = `flex py-2 text-[13px] text-white transition-all uppercase font-normal tracking-widest border-l border-white/5 ${isNested ? 'pl-10' : 'pl-6 ml-2'}`;

    const content = (
      <>
        <span className="mr-3 shrink-0">-</span>
        <span className="flex-1">{label}</span>
      </>
    );

    if (!to) {
      return (
        <div onClick={onClick} className={`${commonClasses} cursor-pointer hover:text-[#64a106]`}>
          {content}
          <span className="ml-2 text-[10px]">
            {isHappinessOpen ? <FaChevronUp /> : <FaChevronDown />}
          </span>
        </div>
      );
    }
    console.log("Scrolled =", scrolled);

    return (
      <Link 
        to={to} 
        onClick={() => setIsOpen(false)} 
        className={`${commonClasses} hover:text-[#64a106]`}
      >
        {content}
      </Link>
    );
  };

  return (
    // <header 
    //   id="navbar" 
    //   className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
    //     scrolled
    //       ? '!bg-[#54a50f] shadow-lg h-16'
    //       : 'bg-black/40 backdrop-blur-sm h-20'
    //   } border-none`} 
    // >

    <header
      id="navbar"
      className="fixed top-0 left-0 w-full z-50 transition-all duration-500"
      style={{
        background: scrolled
          ? "#54a50f"
          : "transparent",
        height: scrolled ? "64px" : "80px"
      }}
    >
      <div className="container mx-auto px-4 md:px-10 h-full flex items-center justify-between relative">
        
        <div className="flex items-center gap-3 flex-1">
          <Link to="/TGSH" className="flex items-center gap-3">
            <img
                src={logo}
                alt="Logo"
                className={`transition-all duration-300 object-contain ${
                  scrolled
                    ? 'h-10 md:h-12 w-auto'
                    : 'h-10 md:h-12 w-auto'
                }`}
            />
            <div className="text-white text-[14px] md:text-[16px] font-sans font-bold uppercase tracking-widest leading-tight hidden sm:block">
              <p className="whitespace-nowrap">The global school of Happiness</p>
            </div>
          </Link>
        </div>

        <div className="flex items-center gap-6 text-white">
          <div className="hidden lg:flex gap-4 text-sm">
            <i className="fa fa-facebook cursor-pointer text-white"></i>
            <i className="fa fa-twitter cursor-pointer text-white"></i>
            <i className="fa fa-instagram cursor-pointer text-white"></i>
          </div>
          
          <button 
            onClick={toggleMenu} 
            className="text-3xl cursor-pointer focus:outline-none transition-transform active:scale-90"
          >
            {isOpen ? '✕' : '☰'}
          </button>
        </div>

        {isOpen && (
          <div 
            className="fixed inset-0 bg-black/40 z-[90] transition-opacity duration-300"
            onClick={() => setIsOpen(false)} // Baher click kelyas minimize hoil
          ></div>
        )}

        {/* Sidebar Menu - Only for Public Users */}
        <div 
          className={`fixed right-0 bg-[#1a1a1a] transition-all duration-500 ease-in-out z-[100] shadow-2xl border-l border-white/5 ${
            isOpen ? 'translate-x-0 w-full md:w-80 opacity-100 visible' : 'translate-x-full w-0 opacity-0 invisible'
          } overflow-y-auto`}
          style={{ 
            // Navbar chya agdi khalun start hoil (2px gap fix kela aahe)
            top: scrolled ? '60px' : '80px', 
            height: scrolled ? 'calc(100vh - 64px)' : 'calc(100vh - 80px)' 
          }}
        >
          <div className="flex flex-col p-8 text-white gap-3 uppercase text-[12px] font-bold tracking-widest pt-10">
          
            <Link 
              to="/TGSH" 
              onClick={toggleMenu} 
              className="text-white border-b border-white/5 pb-3 hover:text-[#64a106] hover:bg-white/5 hover:pl-2 transition-all duration-300"
            >
              Home
            </Link>

            {/* Public Menu Items */}
            {[
              { id: 'org', label: 'Organization', items: [
                { to: "/TGSH/org/intro", label: "Introduction" },
                { to: "/TGSH/org/mission", label: "Mission And Vision" },
                { to: "/TGSH/org/founder", label: "Founder" },
                { to: "/TGSH/org/panel", label: "Panel Members" },
                { to: "/TGSH/org/awards", label: "National Awards" }
              ]},
              { id: 'courses', label: 'Courses' }, 
              { id: 'pub', label: 'Publications', items: [
                { to: "/TGSH/publication/BookRelease", label: "Book Release" }, 
                { to: "/TGSH/publication/News", label: "News" }
              ]},
              { id: 'gal', label: 'Gallery', items: [
                { to: "/TGSH/gallery/DawadiCenter", label: "Dawadi Center" },
                { to: "/TGSH/gallery/Events", label: "Events" },
                { to: "/TGSH/gallery/Workshop", label: "Workshop" }
              ]},
              { id: 'blog', label: 'Blog', items: [{ to: "/TGSH/blog/Article", label: "Article" }]},
              { 
                id: 'feed', 
                label: 'Feedback', 
                items: [
                  { to: "/TGSH/feedback/Statements", label: "Statements" },
                  { to: "/TGSH/feedback/Videos", label: "Videos" }
                ]
              },
              { 
                id: 'contact', 
                label: 'Contact', 
                items: [
                  { to: "/TGSH/contact", label: "Contact Us" } 
                ]
              },
              { id: 'partnership', label: 'Partnership', items: [{ to: "/TGSH/partnership", label: "Partnership" }]}
            ].map((menu) => (
              <div key={menu.id} className="group">
                <div 
                  onClick={() => toggleDropdown(menu.id)} 
                  className="flex justify-between items-center cursor-pointer text-white border-b border-white/5 pb-3 hover:bg-white/5 hover:pl-2 transition-all duration-300"
                >
                  <span className="group-hover:text-[#64a106]">{menu.label}</span>
                  {activeDropdown === menu.id ? <FaChevronUp className="text-[10px]" /> : <FaChevronDown className="text-[10px]" />}
                </div>

                <div className={`overflow-hidden transition-all duration-300 ${activeDropdown === menu.id ? 'max-h-[1000px] opacity-100 py-2' : 'max-h-0 opacity-0'}`}>
                  {menu.id === 'courses' ? (
                    <>
                      <SubMenuLink to="/TGSH/courses/mudra" label="Mudra Abhyas" />
                      <SubMenuLink 
                        to={null} 
                        label="Happiness Ambassador" 
                        onClick={(e) => { e.stopPropagation(); setIsHappinessOpen(!isHappinessOpen); }} 
                      />
                      <div className={`overflow-hidden transition-all duration-300 ${isHappinessOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`}>
                        <SubMenuLink to="/TGSH/courses/happiness-ambassador/student" label="Design Student" isNested={true} />
                        <SubMenuLink to="/TGSH/courses/happiness-ambassador/men" label="Design Men" isNested={true} />
                        <SubMenuLink to="/TGSH/courses/happiness-ambassador/women" label="Design Women" isNested={true} />
                      </div>
                      <SubMenuLink to="/TGSH/courses/MotivationalLecture" label="Motivational Lecture" />
                      <SubMenuLink to="/TGSH/courses/HappinessIndexCorporate" label="Happiness Index Corporate" />
                      <SubMenuLink to="/TGSH/courses/SelfandPublicSpeaking" label="Self and Public Speaking" />
                      <SubMenuLink to="/TGSH/courses/Shitsmart" label="Shit Smart" />
                      <SubMenuLink to="/TGSH/courses/HowtobeacelebrityAuthor" label="Celebrity Author" />
                    </>
                  ) : (
                    menu.items?.map((sub, idx) => (
                      <SubMenuLink key={idx} to={sub.to} label={sub.label} />
                    ))
                  )}
                </div>
              </div>
            ))}
            <Link to="/TGSH/login" onClick={toggleMenu} className="text-white border-b border-white/10 pb-2">Login and register</Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;